// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070035/js/" + chunkId + "." + {"44":"f39308b8","225":"bb35b1ca","481":"216e8bb5","486":"4076cc43","770":"3acd8a22"}[chunkId] + ".0.6848954775364078.chunk.js";
};